var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-a-report"},[_c('pscs-tab-cards-dx',{attrs:{"title":"Create a Report","base-config":_vm.baseConfig,"tabs":_vm.tabs,"submit-text":"Generate"},on:{"tab-rendered":function($event){return _vm.onTabRendered()},"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }